import axios from "axios";
import { handleSuccessOne, handleErrorOne } from "@store/action/GlobalAction";
import { UploadSuccess } from "@src/redux/action/planning/EpisodeAction";

const API = process.env.REACT_APP_MICRO_PLANING_URL;

export const getPodcast = (params) => (dispatch) => {
  axios
    .get(
      `${API}/podcasts/pagination-by-radio/${params?.per_page}?page=${params?.page}`
    )
    .then((response) => {
      dispatch({
        type: "GET_All_PODCASTS",
        data: response.data?.data.data,
        totalPages: response.data?.data?.data.total,
        params,
      });
    });
};
export const getPodcastById = (id) => (dispatch) => {
  axios.get(`${API}/podcasts/${id}`).then((response) => {
    dispatch({
      type: "GET_PODCAST_ID",
      selectedPodcast: response.data.data,
    });
  });
};
export const getFullPodcast = (params) => (dispatch) => {
  axios
    .get(
      `${API}/podcast/fullpodcast/radio/${params.search ? params.search : ""}`,
      {
        params: {
          per_page: params.per_page,
          page: params.page,
        },
      }
    )
    .then((response) => {
      dispatch({
        type: "GET_FULL_PODCASTS",
        data: response.data.data.data,
        totalPages: response.data.data.total,
        params,
      });
    });
};
export const createPodcast = (data) => (dispatch) => {
  const formData = new FormData();
  formData.append("name", data.name);
  formData.append("episode_id", data.episode_id);
  formData.append("record_datetime", data.record_datetime);
  formData.append("playtime_sec", data.playtime_sec);
  formData.append("file_path", data.files);
  const config = {
    onUploadProgress: (progressEvent) => {
      let { loaded, total } = progressEvent;
      let percentComplete = loaded / total;
      percentComplete = parseInt(percentComplete * 100);
      dispatch(UploadSuccess(percentComplete));
    },
  };
  axios
    .post(`${API}/podcasts`, formData, config)
    .then((res) => {
      dispatch({
        type: "ADD_PODCAST_SUCCESS",
      });
      handleSuccessOne(res.data.message, () => {
        dispatch(UploadSuccess(-1));
      });
    })
    .catch((err) => {
      if (err.response.data.code === 504) {
        return dispatch(createPodcast(formData));
      }
      throw new Error(`Request failed with status ${err.response.data.code}`);
    });
};
export const editPodcast = (id, info, func, params) => async (dispatch) => {
  await axios
    .put(`${API}/update-podcast/${id}`, info)
    .then((response) => {
      dispatch({
        type: "EDIT_PODCAST_SUCCESS",
        payload: response.data,
      });
      func();
      handleSuccessOne(response.data.message);
      dispatch(getPodcast(params));
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "EDIT_PODCAST_FAIL",
          payload: err.response.data.message,
        });
        setTimeout(() => {
          dispatch({
            type: "EDIT_PODCAST_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
export const deletePodcast = (id, params) => (dispatch) => {
  axios
    .delete(`${API}/podcasts/${id}`)
    .then((res) => {
      if (res.data.code === 200) {
        handleSuccessOne(res.data.message);
        dispatch(getPodcast(params));
      }
    })
    .catch((err) => {
      if (err.response) {
        handleErrorOne(err.response.data.message);
      }
    });
};

export const getCommentByPodcastId = (id, params) => (dispatch) => {
  axios
    .get(
      `${API}/podcast/comment/${id}?per_page=${params.per_page}&page=${params.page}`
    )
    .then((response) => {
      dispatch({
        type: "GET_COMMENT_BY_PODCAST",
        Comments: response.data.data.data,
        length: response.data.data.total,
      });
    });
};
export const addCommentByPodcast = (data, id, func, params) => (dispatch) => {
  axios
    .post(`${API}/podcast/comment/${id}`, data)
    .then((res) => {
      dispatch({
        type: "ADD_COMMENT_PODCAST_SUCCESS",
        payload: res.data,
      });
      func();
      handleSuccessOne(res.data.message);
      dispatch(getCommentByPodcastId(id, params));
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "ADD_COMMENT_PODCAST_FAIL",
          payload: err.response.data.message,
        });
        setTimeout(() => {
          dispatch({
            type: "ADD_COMMENT_PODCAST_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
export const getAllPodcastComments = (params) => async (dispatch) => {
  await axios
    .get(
      `${API}/podcast/all-comments/radio?per_page=${params.per_page}&page=${params.page}`,
      params
    )
    .then((response) => {
      dispatch({
        type: "GET_ALL_PODCAST_COMMENTS",
        data: response.data.data?.data,
        totalPages: response.data.data?.total,
        params,
      });
    });
};
export const EditStatusComment =
  (idpo, idcom, active, params) => (dispatch) => {
    const data = {
      active: active,
    };
    axios
      .put(`${API}/podcast/comment/${idpo}/${idcom}`, data)
      .then((response) => {
        dispatch({
          type: "EDIT_STATUS_COMMENT_PODCAST_SUCCESS",
          payload: response.data,
        });
        {
          active === 0
            ? handleSuccessOne("comment status switched to Drafted ")
            : handleSuccessOne("comment status switched to Published");
        }
        dispatch(getAllPodcastComments(params));
      })
      .catch((err) => {
        if (err.response) {
          dispatch({
            type: "EDIT_STATUS_COMMENT_PODCAST_FAIL",
            payload: err.response.data.message,
          });
          setTimeout(() => {
            dispatch({
              type: "EDIT_STATUS_COMMENT_PODCAST_FAIL",
              payload: null,
            });
          }, 3000);
        }
      });
  };
export const getLastPodcast = () => (dispatch) => {
  axios.get(`${API}/podcasts/last/5/radio`).then((response) => {
    dispatch({
      type: "GET_LAST_PODCASTS",
      Last: response?.data?.data,
    });
  });
};
